export const TransactionTypes = {
  reimbursement: 'Reimbursement',
  incentive: 'Incentive',
}

export const isReimbursement = (transactionType: string) => transactionType === TransactionTypes.reimbursement;

export const isIncentive = (transactionType: string) => transactionType === TransactionTypes.incentive;
